// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isEmpty } from 'lodash/fp';

// Utils
import { toArray } from '../../../common/utils/immutableHelper';
import { createShallowSelector } from '../../utils/milanoteReselect/milanoteReselect';
import { isPlatformPhoneOrMobileMode } from '../../platform/utils/platformDetailsUtils';

// Components
import AccountPopup from '../../workspace/header/workspaceToolsHeader/account/AccountPopup';
import NotificationsPopup from '../../workspace/header/workspaceToolsHeader/notifications/popup/NotificationsPopup';
import BillingAlertPopup from '../../workspace/header/workspaceToolsHeader/account/BillingAlertPopup';
import MobileGuestSettingsPopup from '../../workspace/legacyMobile/MobileGuestSettingsPopup';

import Button from '../buttons/Button';
import Icon from '../icons/Icon';

// Actions
import { closePopup } from './popupActions';
import { activePopupSelector } from './popupOpenSelector';

// Selectors
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Constants
import { PopupIds } from './popupConstants';

// Style
import './PopupPanelMobileContainer.scss';

const SUPPORTED_POPUPS = {
    [PopupIds.USER]: AccountPopup,
    [PopupIds.NOTIFICATIONS]: NotificationsPopup,
    [PopupIds.BILLING_ALERT]: BillingAlertPopup,
    [PopupIds.GUEST_SETTINGS]: MobileGuestSettingsPopup,
};

const getActivePopupElement = (activePopupNames) => {
    for (const popupName of activePopupNames) {
        const PopupElement = SUPPORTED_POPUPS[popupName];

        if (PopupElement) return PopupElement;
    }
};

const activePopupNamesSelector = createShallowSelector(activePopupSelector, (popupsMap) => {
    if (!popupsMap.size) return [];

    return toArray(popupsMap.keySeq());
});

const mapStateToProps = createSelector(
    getPlatformDetailsSelector,
    activePopupNamesSelector,
    (platformDetails, activePopupNames) => ({
        isMobile: isPlatformPhoneOrMobileMode(platformDetails),
        activePopupNames,
    }),
);

const mapDispatchToProps = (dispatch) => ({
    dispatchClosePopup: () => dispatch(closePopup()),
});

const PopupPanelMobileContainer = (props) => {
    if (!props.isMobile || isEmpty(props.activePopupNames)) return null;

    const PopupElement = getActivePopupElement(props.activePopupNames);
    if (!PopupElement) return null;

    return (
        <div className="PopupPanelMobileContainer">
            <div className="mobile-header">
                <Button onClickFn={props.dispatchClosePopup}>
                    <Icon name="close-x" />
                </Button>
            </div>

            <PopupElement {...props} isMobileView />
        </div>
    );
};

PopupPanelMobileContainer.propTypes = {
    isMobile: PropTypes.bool,
    activePopupNames: PropTypes.array,
    dispatchClosePopup: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupPanelMobileContainer);
